export default __webpack_public_path__ + "static/media/sukses.e412d40b.png";